import { useLocation } from "react-router";
import BackNavLink from "./BackNavLink";

export default function PageShell({
  title,
  description,
  actions,
  children,
  backFallback = "/dashboard",
  showBack = true,
}) {
  const location = useLocation();
  const onOverview = location.pathname === "/dashboard";

  return (
    <div className="mx-auto max-w-8xl px-4 pb-10 pt-5 sm:px-6 lg:px-8">
      {showBack && !onOverview ? (
        <div className="mb-4">
          <BackNavLink
            fallback={backFallback}
            className="inline-flex items-center gap-1.5 rounded-lg px-1 py-1 text-sm font-semibold text-primary/70 transition-colors hover:text-primary"
            iconClassName="h-4 w-4"
          />
        </div>
      ) : null}
      <div className="mb-6 flex flex-col gap-4 border-b border-primary/[0.06] pb-6 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-primary sm:text-[1.75rem]">
            {title}
          </h1>
          {description && (
            <p className="mt-1.5 max-w-2xl text-sm text-primary/45">{description}</p>
          )}
        </div>
        {actions && <div className="flex shrink-0 flex-nowrap items-center gap-2 overflow-x-auto">{actions}</div>}
      </div>
      {children}
    </div>
  );
}
